import { render, staticRenderFns } from "./scorecard-order-clubspecific-step2.vue?vue&type=template&id=3234a59a&scoped=true"
import script from "./scorecard-order-clubspecific-step2.vue?vue&type=script&lang=js"
export * from "./scorecard-order-clubspecific-step2.vue?vue&type=script&lang=js"
import style0 from "./scorecard-order-clubspecific-step2.vue?vue&type=style&index=0&id=3234a59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3234a59a",
  null
  
)

export default component.exports